import { VxNode } from './parser.js';

export function isContainerNode(vxNode: VxNode): boolean {
    if (vxNode.tagName === 'select') {
        return false;
    }
    const children = vxNode.children ?? [];
    const hasTextChildren = children.some(child => !child.tagName);
    return children.length > 0 && !hasTextChildren;
}

export function isObjectEmpty(obj: Record<string, any>): boolean {
    return !Object.values(obj).some(value => !!value);
}

export function normalizeRef(ref: string): string {
    return String(ref).toLowerCase().trim()
        .replace(/ref=/gi, '')
        .replace(/[^a-z0-9]/gi, '');
}

export function* iterate<T>(items: ArrayLike<T> | null | undefined): IterableIterator<T> {
    if (!items) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < items.length; i += 1) {
        const item = items[i];
        yield item;
    }
}
